import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';

class YandexPanorama extends Component {
  constructor (props) {
    super(props);

    this.state = {
      loadFailed: false
    };

    this.lat = Number(props.lat);
    this.lon = Number(props.lon);
    this.player = null;
  }

  componentDidMount () {
    window.ymaps.ready(() => {
      const panorama = window.ymaps.panorama;

      if (!panorama.isSupported()) {
        this.setState({ loadFailed: true, error: 'Устройство не поддерживает панорамы' });
        this.props.onLoad(false);
        return false;
      }

      const node = findDOMNode(this);
      const locateRequest = panorama.locate([this.lat, this.lon]);
      locateRequest.then(
        (panoramas) => {
          if (panoramas.length) {
            this.player = new panorama.Player(node, panoramas[0], {
              controls: ['panoramaName', 'fullscreenControl', 'zoomControl']
            });
            this.props.onLoad(true);
          } else {
            this.setState({ loadFailed: true, error: 'Панорама для местности не найдена' });
            this.props.onLoad(false);
          }
        }
      ).catch((e) => {
        this.setState({ loadFailed: true, error: e.message });
        this.props.onLoad(false);
      });
    });
  }

  componentWillUnmount () {
    if (this.player) {
      this.player.destroy();
    }
  }

  render () {
    return (
      <div className='panorama-content panorama-yandex'>
        {this.state.loadFailed && <div className='error'>{this.state.error}</div>}
      </div>
    );
  }
}

YandexPanorama.propTypes = {
  lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  lon: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onLoad: PropTypes.func
};

YandexPanorama.defaultProps = {
  onLoad: (isLoad) => {}
};

export default YandexPanorama;



// WEBPACK FOOTER //
// ./src/ui/Maps/Panoramas/YandexPanorama.jsx